import { Navigate, Outlet } from 'react-router-dom';
import { hasPermission } from '../hooks/usePermission';

const PermissionRoute = ({ permission }) => {
  if (!hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;